var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#user--access_svg__clip0_61530_7244)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5h-1.5v-3.75a2.253 2.253 0 00-2.25-2.25h-3A2.253 2.253 0 003 18.75v3.75H1.5v-3.75A3.755 3.755 0 015.25 15h3A3.755 3.755 0 0112 18.75v3.75zM6.75 7.5a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zm0-1.5a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zM22.5 9c-.13.002-.259.02-.384.056l-.791-.792a2.909 2.909 0 000-3.028l.791-.792a1.525 1.525 0 10-1.06-1.06l-.792.791a2.909 2.909 0 00-3.028 0l-.792-.791a1.525 1.525 0 10-1.06 1.06l.791.792a2.91 2.91 0 000 3.028l-.791.792a1.525 1.525 0 101.06 1.06l.792-.791a2.91 2.91 0 003.028 0l.791.791A1.497 1.497 0 1022.5 9zm-5.25-2.25a1.5 1.5 0 112.999 0 1.5 1.5 0 01-3 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "user--access_svg__clip0_61530_7244"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgUserAccess;